import { render } from "./PatientImageSwiper.vue?vue&type=template&id=002c9d62&scoped=true"
import script from "./PatientImageSwiper.vue?vue&type=script&lang=js"
export * from "./PatientImageSwiper.vue?vue&type=script&lang=js"

import "./PatientImageSwiper.vue?vue&type=style&index=0&id=002c9d62&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002c9d62"]])

export default __exports__